(function () {
    function getScrollOffset(root) {
      var rootStyles = getComputedStyle(root);
      var settingOffset = parseInt(rootStyles.getPropertyValue('--ns-scroll-offset'), 10) || 120;
      var header = document.querySelector('.site-header');
      var headerHeight = header ? header.offsetHeight : 0;
      return Math.max(settingOffset, headerHeight + 30);
    }
  
    function scrollToHeading(root, heading) {
      var offset = getScrollOffset(root);
      var top = heading.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
      history.replaceState(null, '', '#' + heading.id);
    }
  
    function initFaq(content) {
      if (!content || content.dataset.nsFaqInit === 'true') return;
      content.dataset.nsFaqInit = 'true';
  
      content.querySelectorAll('.faq-section').forEach(function (section) {
        section.classList.add('ns-faq', 'ns-faq--ready');
        section.querySelectorAll('details').forEach(function (item) {
          item.classList.add('ns-faq__item');
          var summary = item.querySelector('summary');
          if (summary) summary.classList.add('ns-faq__question');
          var answer = item.querySelector('.ns-faq__answer');
          if (!answer) {
            var wrapper = document.createElement('div');
            wrapper.className = 'ns-faq__answer';
            Array.from(item.children).forEach(function (child) {
              if (child.tagName !== 'SUMMARY') wrapper.appendChild(child);
            });
            if (wrapper.childNodes.length) item.appendChild(wrapper);
          }
        });
  
        var firstManual = section.querySelector('details.ns-faq__item');
        if (firstManual && !section.querySelector('details[open]')) {
          firstManual.open = true;
        }
  
        bindFaqAccordion(section);
      });
  
      content.querySelectorAll('h2').forEach(function (h2) {
        if (!/faq/i.test(h2.textContent)) return;
        if (h2.nextElementSibling && h2.nextElementSibling.classList.contains('ns-faq')) return;
  
        if (!h2.id) h2.id = 'faq';
  
        var nodes = [];
        var el = h2.nextElementSibling;
        while (el && el.tagName !== 'H2') {
          nodes.push(el);
          el = el.nextElementSibling;
        }
  
        if (!nodes.length) return;
  
        var wrapper = document.createElement('div');
        wrapper.className = 'ns-faq ns-faq--auto';
        h2.insertAdjacentElement('afterend', wrapper);
  
        var group = [];
  
        function flushGroup() {
          if (!group.length) return;
  
          var questionNode = group.find(function (n) {
            return n.tagName === 'H3';
          });
  
          if (!questionNode) {
            group.forEach(function (n) {
              wrapper.appendChild(n);
            });
            group = [];
            return;
          }
  
          var details = document.createElement('details');
          details.className = 'ns-faq__item';
  
          var summary = document.createElement('summary');
          summary.className = 'ns-faq__question';
          summary.textContent = questionNode.textContent.trim();
          questionNode.remove();
  
          var answer = document.createElement('div');
          answer.className = 'ns-faq__answer';
  
          group.forEach(function (n) {
            if (n === questionNode || !n.parentNode) return;
            answer.appendChild(n);
          });
  
          details.appendChild(summary);
          details.appendChild(answer);
  
          if (!wrapper.querySelector('.ns-faq__item')) {
            details.open = true;
          }
  
          wrapper.appendChild(details);
          group = [];
        }
  
        nodes.forEach(function (node) {
          if (node.tagName === 'H3') {
            flushGroup();
            group.push(node);
          } else {
            group.push(node);
          }
        });
  
        flushGroup();
  
        var firstAuto = wrapper.querySelector('.ns-faq__item');
        if (firstAuto && !wrapper.querySelector('details[open]')) {
          firstAuto.open = true;
        }
  
        bindFaqAccordion(wrapper);
  
        /* Remove leftover h3 text that was not moved into the accordion */
        var stray = wrapper.nextElementSibling;
        while (stray && stray.tagName !== 'H2') {
          var next = stray.nextElementSibling;
          if (stray.tagName === 'H3' && !stray.closest('.ns-faq')) {
            stray.remove();
          }
          stray = next;
        }
      });
    }
  
    function bindFaqAccordion(wrapper) {
      if (wrapper.dataset.nsFaqAccordion === 'true') return;
      wrapper.dataset.nsFaqAccordion = 'true';
  
      wrapper.addEventListener('toggle', function (event) {
        var item = event.target;
        if (item.tagName !== 'DETAILS' || !item.open) return;
  
        wrapper.querySelectorAll('details.ns-faq__item[open]').forEach(function (openItem) {
          if (openItem !== item) openItem.open = false;
        });
      });
    }
  
    function initToc(root, content) {
      var toc = root.querySelector('[data-blog-toc]');
      var tocList = root.querySelector('[data-toc-list]');
      if (!toc || !tocList || !content) return;
  
      var headings = content.querySelectorAll('h2');
      if (!headings.length) {
        toc.hidden = true;
        return;
      }
  
      headings.forEach(function (heading, index) {
        if (!heading.id) {
          heading.id = 'section-' + (index + 1);
        }
  
        var li = document.createElement('li');
        var link = document.createElement('a');
        link.className = 'blog-toc__link';
        link.href = '#' + heading.id;
        link.textContent = heading.textContent.trim();
        link.addEventListener('click', function (event) {
          event.preventDefault();
          scrollToHeading(root, heading);
        });
        li.appendChild(link);
        tocList.appendChild(li);
      });
  
      toc.hidden = false;
  
      var links = tocList.querySelectorAll('a');
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            links.forEach(function (link) {
              link.classList.toggle('is-active', link.getAttribute('href') === '#' + entry.target.id);
            });
          });
        },
        { rootMargin: '-20% 0px -70% 0px', threshold: 0 }
      );
  
      headings.forEach(function (heading) {
        observer.observe(heading);
      });
    }
  
    function initProgress(root, content) {
      var progress = root.querySelector('[data-reading-progress]');
      if (!progress || !content) return;
  
      var onScroll = function () {
        var start = content.offsetTop;
        var height = content.offsetHeight - window.innerHeight;
        var scrollTop = window.scrollY || document.documentElement.scrollTop;
        var percent = height > 0 ? Math.min(100, Math.max(0, ((scrollTop - start) / height) * 100)) : 0;
        progress.style.width = percent + '%';
      };
  
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  
    function initBlog(root) {
      if (!root || root.dataset.nsBlogInit === 'true') return;
      root.dataset.nsBlogInit = 'true';
  
      var content = root.querySelector('.blog-content');
      initProgress(root, content);
      initFaq(content);
      initToc(root, content);
    }
  
    function boot() {
      document.querySelectorAll('[data-nightstick-blog]').forEach(function (root) {
        initBlog(root);
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-nightstick-blog]');
      if (root) initBlog(root);
    });
})();